import { API_URL } from "../Constants"
import { startLoading, endLoading, SnackBar } from './Common';
import store from "../store"

export function pageErrors(errors = null, page = null) {
    return { type: 'PAGE_ERRORS', errors, page };
}

export function storeRegisterDetails(username, pin, token, user, keep_login) {
    return { type: 'STORE_REGISTER_DETAILS', register: { username, pin }, token, user, keep_login };
}

export function register(data, keep_login) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Creating user..', 'info'))
        fetch(API_URL + "auth/register", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(storeRegisterDetails(json.username, json.pin, json.token,
                        { username: json.username, id: json.user_id, token: json.token, essential_test: false, voluntary_test: false }, keep_login))
                } else {
                    if (json.errors !== undefined) { dispatch(pageErrors(json.errors, "register")) }
                    else if (json.message !== undefined) {
                        dispatch(SnackBar(true, json.message, 'danger'))
                    }
                }
                dispatch(endLoading())
            })
    }
}

export function storeToken(token, user, baseline, keep_login) {
    return { type: 'STORE_ACCESS_TOKEN', token, user, baseline, keep_login };
}


export function twoFactorDialog(bool) {
    return { type: 'TWO_FACTOR_DIALOG', bool };
}

export function login(data, keep_login) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "auth/login", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(storeToken(json.access_token, json, json.baseline, keep_login))
                    dispatch(twoFactorDialog(json.two_factor_enabled))
                } else {
                    if (json.message !== undefined) {
                        dispatch(SnackBar(true, json.message, 'danger'))
                    }
                }
                dispatch(endLoading())
            })
    }
}

export function recoveryError(message = null) {
    return { type: 'RECOVERY_ERROR', message };
}

export function redirectPage(page = "") {
    return { type: 'REDIRECT_PAGE', page };
}

export function passwordMail(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "auth/recovery", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(SnackBar(true, 'Mail Sent', 'success'))
                    dispatch(redirectPage("Reset Pin"))
                } else if (json.status === "error") {
                    dispatch(recoveryError(json.message))
                }
                dispatch(endLoading())
            })
    }
}

export function handleResetPin(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "auth/resetpin", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(redirectPage("pin updated"))
                } else {
                    if (json.errors !== undefined) { dispatch(pageErrors(json.errors, "resetpin")) }
                    else if (json.message !== undefined) {
                        dispatch(SnackBar(true, json.message, 'danger'))
                    }
                }
                dispatch(endLoading())
            })
    }
}


export function handleChangePin(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "auth/changepin", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(redirectPage("pin updated"))
                } else {
                    if (json.errors !== undefined) { dispatch(pageErrors(json.errors, "resetpin")) }
                    else if (json.message !== undefined) {
                        dispatch(SnackBar(true, json.message, 'danger'))
                    }
                }
                dispatch(endLoading())
            })
    }
}

export function storeProfile(profile = null) {
    return { type: 'STORE_PROFILE', profile };
}

export function getPofile() {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "account/profile", {
            method: "GET",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            }
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                dispatch(storeProfile(json))
                dispatch(endLoading())
            })
    }
}

export function updateProfile(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "account/profile", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(SnackBar(true, 'Profile updated', 'success'))
                }
                dispatch(endLoading())
            })
    }
}

export function updateReminders(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "account/reminder-settings", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(getPofile())
                    dispatch(redirectPage("dashboard"))
                    dispatch(SnackBar(true, 'Reminder updated', 'success'))
                }
                dispatch(endLoading())
            })
    }
}

export function contactMailSend(bool) { return { type: 'CONTACT_MAIL_SEND', bool } }

export function sendMessage(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "contact-us/message", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(SnackBar(true, 'Message sent', 'success'))
                    dispatch(contactMailSend(true))
                } else {
                    if (json.message !== undefined) {
                        dispatch(SnackBar(true, json.message, 'danger'))
                    }
                }
                dispatch(endLoading())
            })
    }
}

export function logout() { return { type: 'CLEAR_USER' } }

export function storeCompanyDetails(data) { return { type: 'STORE_COMPANY_DETAILS', data } }

export function companyDetails(token) {
    return function (dispatch) {
        dispatch(startLoading())
        fetch(API_URL + "company?t=" + token, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(storeCompanyDetails({ name: json.name, logo: json.logo, type: json.type }))
                } else {
                    if (json.message !== undefined) {
                        dispatch(SnackBar(true, json.message, 'danger'))
                    }
                }
                dispatch(endLoading())
            })
    }
}

export function handleVerifyCode(data) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "auth/2fa/verify", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(data)
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(twoFactorDialog(false))
                } else {
                    if (json.message !== undefined) {
                        dispatch(SnackBar(true, json.message, 'danger'))
                        setTimeout(() => {
                            dispatch(logout());
                        }, 3000)
                        return;
                    }
                }
                dispatch(endLoading())
            })
    }
}